import React, { useState } from "react"; // Added useState
import { Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter } from "react-icons/fa";
import SubscribeModal from "./SubscribeModal";

function Footer() {
  const [modalOpen, setModalOpen] = useState(false); // Added modal state

  return (
    <>
      {/* Contact Section */}
      <section className="contact-section py-5" style={{ marginTop: 40 }}>
        <div className="container">
          <div className="row">
            {/* Production Team */}
            <div className="col-12 col-sm-6 col-md-3 mb-5">
              <h5 className="fw-bold section-heading">Production Team</h5>
              <p className="mb-1 mt-2">
                <strong>Ben Scott</strong>
                <br />
                <span className="text-muted small">Conference Producer</span>
              </p>
              <a href="mailto:ben.scott@aroevents.com">ben.scott@aroevents.com</a>
            </div>

            {/* Sponsorship & Media Team */}
            <div className="col-12 col-sm-6 col-md-3 mb-5">
              <h5 className="fw-bold section-heading">Sponsorship & Media Team</h5>
              <p className="mb-1 mt-2">
                <strong>Amy Wilson</strong>
                <br />
                <span className="text-muted small">Assistant Sponsorship Director</span>
              </p>
              <a href="mailto:amy.wilson@aroevents.com">amy.wilson@aroevents.com</a>
            </div>

            {/* Delegate Registration */}
            <div className="col-12 col-sm-6 col-md-3 mb-5">
              <h5 className="fw-bold section-heading">Delegate Registration</h5>
              <p className="mb-1 mt-2">
                <strong>Tom Harris</strong>
                <br />
                <span className="text-muted small">Delegate Sales Manager</span>
              </p>
              <a href="mailto:tom.harris@aroevents.com">tom.harris@aroevents.com</a>
            </div>

            {/* General Inquiries */}
            <div className="col-12 col-sm-6 col-md-3 mb-5">
              <h5 className="fw-bold section-heading">General Inquiries</h5>
              <p className="mb-1 mt-2">
                <strong>Support Team</strong>
                <br />
                <span className="text-muted small">General Support</span>
              </p>
              <a href="mailto:info@aroevents.com">info@aroevents.com</a>
            </div>
          </div>
        </div>

        {/* Styling */}
        <style>{`
          .contact-section {
            background-color: #f8f9fa;
            padding: 40px 20px;
            max-width: 1200px;
            margin: 0 auto;
            border-radius: 8px;
          }

          /* heading separation */
          .section-heading {
            font-size: 1rem;
            color: #000;
            text-transform: uppercase;
            padding-top: 10px;
            margin-top: 0;
            border-top: 1px solid #dcdcdc; /* subtle line above heading */
            padding-bottom: 4px;
            margin-bottom: 10px;
          }

          .contact-section p {
            font-size: 0.95rem;
            color: #333;
            margin-bottom: 6px;
          }

          .contact-section a {
            color: #2a4d9c;
            text-decoration: none;
            display: inline-block;
            margin-top: 2px;
            word-break: break-word;
          }
          .contact-section a:hover {
            text-decoration: underline;
          }

          /* Mobile and tablet */
          @media (max-width: 767px) {
            .contact-section {
              text-align: center;
              padding: 20px 15px;
            }
            .section-heading {
              border-top-width: 2px; /* slightly stronger on mobile */
              padding-top: 12px;
            }
          }
        `}</style>
      </section>

      {/* Footer Section */}
      <footer style={{ backgroundColor: "#fafafa", color: "#555", fontFamily: "Arial, sans-serif" }}>
        {/* Top Section: Mailing List + Social Icons */}
        <div className="container text-center py-4" style={{ borderBottom: "1px solid #e5e5e5" }}>
          <div className="row align-items-center">
            {/* Mailing List */}
            <div className="col-md-6 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start align-items-center flex-wrap">
              <span style={{ fontSize: "16px", marginRight: "10px" }}>
                Join the mailing list for the latest ARO events updates.
              </span>
              <button
                onClick={() => setModalOpen(true)}
                style={{
                  display: "inline-block",
                  border: "1px solid #333",
                  background: "transparent",
                  padding: "6px 20px",
                  borderRadius: "25px",
                  fontSize: "14px",
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "#333",
                }}
              >
                Sign up
              </button>
            </div>

            {/* Social Icons */}
            <div className="col-md-6 d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-center">
              <span style={{ marginRight: "10px", whiteSpace: "nowrap" }}>
                Stay connected with ARO events on social.
              </span>
              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                <a
                  href="https://www.facebook.com/share/16jvYa6rF7/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#555", fontSize: "18px" }}
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://x.com/AroEvents"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#555", fontSize: "18px" }}
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://www.instagram.com/aro_events_?igsh=c2N5Z2diazZxN29y&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#555", fontSize: "18px" }}
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.linkedin.com/company/aro-events/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#555", fontSize: "18px" }}
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section: Copyright + Links */}
        <div className="text-center py-3" style={{ fontSize: "14px", color: "#777" }}>
          <p style={{ margin: 0 }}>
            Copyright © 2025 ARO events or its affiliates. All rights
            reserved.
          </p>
          <div className="d-flex justify-content-center flex-wrap gap-2 mt-2" style={{ fontSize: "14px" }}>
            <Link to="/terms" style={{ color: "#555", textDecoration: "none" }}>
              Privacy Policy
            </Link>{" "}
            /{" "}
            <Link
              to="/terms#websiteContent"
              style={{ color: "#555", textDecoration: "none" }}
            >
              Terms of Use
            </Link>{" "}
            /{" "}
            <Link
              to="/terms#whatAreCookies"
              style={{ color: "#555", textDecoration: "none" }}
            >
              Cookie preferences
            </Link>{" "}
            /{" "}
            <Link
              to="/terms#scope"
              style={{ color: "#555", textDecoration: "none" }}
            >
              Code Of Conduct
            </Link>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <SubscribeModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}

export default Footer;
